import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { selectUser } from '../state/session/session.selectors';
import { EUserPhoneNumberStatus } from '../enums';
import { VerifyUserPhoneNumberModalComponent } from '../../shared/components/verify-user-phone-number-modal/verify-user-phone-number-modal.component';

@Injectable({ providedIn: 'root' })
export class PhoneNumberCheckerService {
  subscription: Subscription = new Subscription();
  userPhoneNumberStatus?: EUserPhoneNumberStatus;

  constructor(
    private dialogService: MatDialog,
    private store$: Store
  ) {}

  init() {
    this.subscription.add(
      this.store$.select(selectUser).subscribe(user => {
        if (!user) {
          return;
        }
        this.userPhoneNumberStatus = user.phoneNumberStatus;
      })
    );
  }

  checkIfUserPhoneVerified() {
    if (this.userPhoneNumberStatus === EUserPhoneNumberStatus.VERIFIED) {
      return true;
    }

    this.dialogService.open(VerifyUserPhoneNumberModalComponent, {
      maxHeight: '100vh',
      maxWidth: '100vw',
      data: { userPhoneNumberStatus: this.userPhoneNumberStatus },
    });

    return false;
  }
}
